import Student from '@/models/Students/Student'
import _ from 'lodash'
import sort from '@/services/sorting'

import router from '@/routes'
import store from '@/store'

import {ActiveTableConfig} from '@/components/Ui/ActiveTable/BZCore/ActiveTable'
import {ActiveFieldOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveField'
import {TableOptions} from '@/components/Ui/ActiveForm/BZCore/Table/Table'

import StringField from '@/components/Ui/ActiveForm/BZCore/Fields/StringField'
import NumberField from '@/components/Ui/ActiveForm/BZCore/Fields/NumberField'
import SelectField, {SelectFieldOptions} from '@/components/Ui/ActiveForm/BZCore/Fields/SelectField'

import StudentIndexColumn from '@/components/Students/Table/StudentIndexColumn.vue'
import StudentDetailRow from '@/components/Students/Table/StudentDetailRow.vue'
import StudentStatus from '@/components/Students/Table/StudentStatus.vue'

import FirstName from '@/components/Students/Table/cols/firstName.vue'
import LastName from '@/components/Students/Table/cols/lastName.vue'
import MiddleName from '@/components/Students/Table/cols/middleName.vue'
import Messengers from '@/components/Students/Table/cols/messengers.vue'
import StudentsForm from '@/components/Students/Table/cols/form.vue'
import Faculty from '@/components/Students/Table/cols/faculty.vue'
import Course from '@/components/Students/Table/cols/course.vue'
import Group from '@/components/Students/Table/cols/group.vue'
import Financing from '@/components/Students/Table/cols/financing.vue'
import Program from '@/components/Students/Table/cols/program.vue'
import Term from '@/components/Students/Table/cols/term.vue'
import State from '@/components/Students/Table/cols/state.vue'
import HalfYear from '@/components/Students/Table/cols/halfYear.vue'
import Semester from '@/components/Students/Table/cols/semester.vue'
import Specialty from '@/components/Students/Table/cols/specialty.vue'
import IsAuth from '@/components/Students/Table/cols/isAuth.vue'

// @ts-ignore
import messages from '@/lang/index';

const StudentsActiveTableConfig: ActiveTableConfig<Student> = {
  documentsName: messages.labels.students2,
  indexColumnComponent: StudentIndexColumn,
  defaultPageSize: 10,
  onRowClick ({rowIndex, toggleRowDetail}) {
    toggleRowDetail(rowIndex);
  },
  async find (search, filters, sortKeys, limit, offset) {
    let emptyKeys: string[] = [];
    for (let key in filters) {
      if (Array.isArray(filters[key]) && !filters[key].length) {
        emptyKeys.push(key)
        continue;
      }
      if (filters[key] === '') {
        emptyKeys.push(key)
      }
    }
    for (let key of emptyKeys) {
      delete filters[key]
    }
    console.log('LOG: find -> sort', sortKeys)

    let sort: string[][] = []
    if (Object.keys(sortKeys).length) {
      for (const key in sortKeys) {
        sort.push([key, sortKeys[key]])
      }
    }

    if (!Object.keys(filters).length) {
      return {
        count: 0,
        list: []
      }
    };

    const params = {
      query: filters,
      limit,
      offset,
      sort
    }
    const result = await store.dispatch('students/findStudents', params)
    console.log('LOG: find -> result', result)
    return {
      count: result.count,
      list: result.studs
    }
  },
  async loadFiltersValues () {
  },
  filtersAndActions: {
    pageName: messages.labels.search_and_filters,
    searchFormButtonText: messages.labels.search_form_button_text,
    searchForm: {
      inputs: {
        last_name: {
          type: StringField,
          label: messages.labels.cols.last_name
        },
        first_name: {
          type: StringField,
          label: messages.labels.cols.first_name
        },
        middle_name: {
          type: StringField,
          label: messages.labels.cols.middle_name
        },
        email: {
          type: StringField,
          label: messages.labels.email
        }
      },
      steps: [
        {map: [['last_name', 'first_name', 'middle_name', 'email']]}
      ]
    },
    filters: {}
  },
  defaultShownColumns: ['last_name', 'first_name', 'middle_name', 'messengers'],
  table: {
    cols: {
      last_name: {label: messages.labels.cols.last_name, component: LastName, sortable: true},
      first_name: {label: messages.labels.cols.first_name, component: FirstName, sortable: true},
      middle_name: {label: messages.labels.cols.middle_name, component: MiddleName, sortable: true},
      messengers: {label: messages.labels.cols.messengers, component: Messengers},
      id: {label: messages.labels.cols.id, isModel: true, sortable: true},
      form: {label: messages.labels.cols.form, component: StudentsForm, sortable: true},
      faculty: {label: messages.labels.cols.faculty, component: Faculty, sortable: true},
      course: {label: messages.labels.cols.course, component: Course, sortable: true},
      group: {label: messages.labels.cols.group, component: Group, sortable: true},
      financing: {label: messages.labels.cols.financing, component: Financing, sortable: true},
      program: {label: messages.labels.cols.program, component: Program, sortable: true},
      term: {label: messages.labels.cols.term, component: Term, sortable: true},
      state: {label: messages.labels.cols.state, component: State, sortable: true},
      half_year: {label: messages.labels.cols.half_year, component: HalfYear, sortable: true},
      semester: {label: messages.labels.cols.semester, component: Semester, sortable: true},
      specialty: {label: messages.labels.cols.specialty, component: Specialty, sortable: true},
      is_auth: {label: messages.labels.cols.is_auth, component: IsAuth, sortable: true}
    },
    detailRowComponent: StudentDetailRow
  } as TableOptions
}
export default StudentsActiveTableConfig